var map = {
	"./jayap.png": 201,
	"./korb.png": 501,
	"./kroostra.png": 992,
	"./kwath.png": 6,
	"./laka.png": 26,
	"./peye.png": 270,
	"./plague-akwin.png": 137,
	"./plague-bokwin.png": 377,
	"./seekalla.png": 967,
	"./shtung.png": 612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 178;